var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7895 21.6855C17.3123 21.6855 21.7895 17.2084 21.7895 11.6855C21.7895 6.1627 17.3123 1.68555 11.7895 1.68555C6.26664 1.68555 1.78949 6.1627 1.78949 11.6855C1.78949 17.2084 6.26664 21.6855 11.7895 21.6855Z",
    stroke: "#0F0E0E",
    strokeWidth: 2.47368
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7895 6.68555V12.6855M11.7895 16.1855V16.6855",
    stroke: "#0F0E0E",
    strokeWidth: 2.47368,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.8b2e8d9744b9ef93745e50e94ad37bfa.svg";
export { ForwardRef as ReactComponent };